<div class="leyendas-cont row-base">
  <div class="contLeyenda contLeyenda--servicio">
    <h6 class="label">Estado del Servicio de Tickets</h6>
    <div class="column-base">
      <div class="row-base leyenda-row">
        <span class="tag-estado tag-estado-serv-Creado">Creado</span>
        <span class="leyenda-description"
          >Los tickets se han creado en la plataforma de Sales.</span
        >
      </div>

      <div class="row-base leyenda-row">
        <span class="tag-estado tag-estado-serv-En-Proceso">En Proceso</span>
        <span class="leyenda-description"
          >Se está gestionando la compra de tickets.</span
        >
      </div>

      <div class="row-base leyenda-row">
        <span class="tag-estado tag-estado-serv-Reservado">Reservado</span>
        <span class="leyenda-description"
          >Se completo la compra de todos los tickets.</span
        >
      </div>

      <div class="row-base leyenda-row">
        <span class="tag-estado tag-estado-serv-Nueva-Adicion"
          >Nueva Adición</span
        >
        <span class="leyenda-description"
          >Se añadieron nuevos paxs y tickets al File/Servicio.</span
        >
      </div>
    </div>
  </div>

  <div class="contLeyenda contLeyenda--gestion">
    <h6 class="label">Estado de Gestión de Tickets</h6>
    <div class="column-base">
      <div class="row-base leyenda-row">
        <span class="tag-estado tag-estado-Creado">Creado</span>
        <span class="leyenda-description"
          >Los tickets se han creado en la plataforma de Sales.</span
        >
      </div>

      <div class="row-base leyenda-row">
        <span class="tag-estado tag-estado-En-Proceso">En Proceso</span>
        <span class="leyenda-description"
          >Se generó la Orden de Servicio para el ticket.</span
        >
      </div>

      <div class="row-base leyenda-row">
        <span class="tag-estado tag-estado-Reservado">Reservado</span>
        <span class="leyenda-description"
          >Se cuenta con efectivo para la compra.</span
        >
      </div>

      <div class="row-base leyenda-row">
        <span class="tag-estado tag-estado-Confirmado">Confirmado</span>
        <span class="leyenda-description"
          >Se subieron los archivos de tickets.</span
        >
      </div>
    </div>
  </div>
</div>
